var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelStripeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 3.5C14.99 3.5 4 14.49 4 28C4 41.51 14.99 52.5 28.5 52.5C42.01 52.5 53 41.51 53 28C53 14.49 42.01 3.5 28.5 3.5ZM40.2423 37.2577C40.9248 37.9402 40.9248 39.0602 40.2423 39.7427C39.8923 40.0752 39.4548 40.2502 38.9998 40.2502C38.5448 40.2502 38.1073 40.0752 37.7573 39.7427L28.4995 30.485L19.2418 39.7427C18.8918 40.0752 18.4543 40.2502 17.9993 40.2502C17.5443 40.2502 17.1068 40.0752 16.7568 39.7427C16.0743 39.0602 16.0743 37.9402 16.7568 37.2577L26.0145 28L16.7568 18.7423C16.0743 18.0598 16.0743 16.9398 16.7568 16.2573C17.4393 15.5748 18.5593 15.5748 19.2418 16.2573L28.4995 25.515L37.7573 16.2573C38.4398 15.5748 39.5598 15.5748 40.2423 16.2573C40.9248 16.9398 40.9248 18.0598 40.2423 18.7423L30.9845 28L40.2423 37.2577Z",
    fill: "#FF453A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelStripeIcon);
export default __webpack_public_path__ + "static/media/cancelStripeIcon.c17d1bc7b3458a79be039d9ea9b2c7c3.svg";
export { ForwardRef as ReactComponent };